import { configureFonts, DefaultTheme, DarkTheme } from 'react-native-paper';

import { ColorsType, oeColors, oeColorsDark, oeColorsBlue } from './oe-colors';
import { paperFontsConfig } from './paper-fonts';

declare global {
  namespace ReactNativePaper {
    interface ThemeColors extends ColorsType {
      backdrop: string;
      disabled: string;
      notification: string;
      onSurface: string;
      placeholder: string;
      surface: string;
      text: string;
    }
  }
}

const themeShared = {
  roundness: 4,
  fonts: configureFonts(paperFontsConfig),
};

export const OeDefaultTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    ...oeColors,
    backdrop: oeColors.dark2,
    disabled: oeColors.disabledGrayedOut,
    notification: oeColors.primary,
    onSurface: oeColors.white,
    placeholder: oeColors.dark3,
    surface: oeColors.surface,
    text: oeColors.black,
    // NOTE: any new color should be added in `oe-colors.ts`, not here
  },
  ...themeShared,
};

export const OeDarkTheme = {
  ...DarkTheme,
  colors: {
    ...DarkTheme.colors,
    ...oeColorsDark,
    backdrop: oeColorsDark.dark2,
    disabled: oeColorsDark.disabledGrayedOut,
    notification: oeColorsDark.primary,
    onSurface: oeColorsDark.white,
    placeholder: oeColorsDark.dark3,
    surface: oeColorsDark.white,
    text: oeColorsDark.black,
    // NOTE: any new color should be added in `oe-colors.ts`, not here
  },
  ...themeShared,
};

export const OeBlueTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    ...oeColorsBlue,
    backdrop: oeColorsBlue.dark2,
    disabled: oeColorsBlue.disabledGrayedOut,
    notification: oeColorsBlue.primary,
    onSurface: oeColorsBlue.white,
    placeholder: oeColorsBlue.dark3,
    surface: oeColorsBlue.white,
    text: oeColorsBlue.black,
  },
  ...themeShared,
};
